<template>
	<div class="m-product" :style="{'background': unitData.show_background != 0 ? unitData.background || '#fff' : 'none'}">
		<sub-image v-if="unitData.show_banner == 1" class="m-product-advert" :src="unitData.banner_img" mode="widthFix"></sub-image>
		<div v-if="unitData.show_title == 1" class="m-product-head flex-between-center">
			<div class="flex-center">
				<sub-image v-if="unitData.title_img" class="image" :src="unitData.title_img" mode="heightFix"></sub-image>
				<p :style="{'font-size': `${(unitData.title_size || 36) / 2}px`, 'color': unitData.color == '2' ? '#fff' : '#000'}">{{unitData.title_text}}</p>
			</div>
			<span v-if="unitData.more_link" class="more" :style="{'color': unitData.color == '2' ? 'rgba(255,255,255,0.6)' : '#999'}">{{unitData.more_text || '查看更多'}}</span>
		</div>
		<div class="m-product-list flex" :style="{'background': unitData.show_background != 0 ? '#fff' : 'none'}">
			<ul class="flex">
				<li v-for="(item, i) in unitData.product_list" :key="item.product_id">
					<sub-image class="image" :src="item.product_img_url"></sub-image>
					<template v-if="unitData.is_point == 1">
						<div v-if="unitData.price_tag == 1" class="tag" :style="{'background-image': `url('${oss('/channel_product_tag.png')}')`}">{{parseFloat(item.sale_price)}}积分</div>
						<p v-else>{{item.sale_price}}积分</p>
					</template>
					<template v-else>
						<div v-if="unitData.price_tag == 1" class="tag" :style="{'background-image': `url('${oss('/channel_product_tag.png')}')`}">￥{{parseFloat(item.sale_price)}}</div>
						<p v-else>￥{{item.sale_price}}</p>
					</template>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product {
		border-radius: 10px;
		margin: 0 12px;
		overflow: hidden;
		background: #fff;
		
		&-head {
			box-sizing: border-box;
			height: 40px;
			padding: 6px 12px 0;
			
			.image {
				height: 24px;
				margin-right: 6px;
			}
			
			p {
				font-size: 18px;
				font-weight: bold
			}
			
			.more {
				font-size: 12px;
				color: #999;
			}
		}
		
		&-list {
			padding: 6px 8px 0;
			border-radius: 4px;
			margin: 0 6px 6px;
			overflow: hidden;
			background: #fff;
			
			ul {
				float: left;
				
				li {
					width: 90px;
					
					&:nth-child(n+2) {
						margin-left: 8px;
					}
					
					.image {
						height: 90px;
					}
					
					.tag {
						box-sizing: border-box;
						width: 82px
						height: 20px;
						padding-left: 34px;
						margin: 6px 0;
						line-height: 20px;
						text-align: center;
						font-size: 12px;
						color: #fff;
						background-size: 100%;
					}
					
					p {
						line-height: 32px;
						font-size: 14px;
						font-weight: bold;
					}
				}
			}
		}
	}
</style>
